import React from 'react';
import { Poppins, Spacer } from 'src/common';
import * as S from './ModalSubTitle.styles';

interface ModalSubTitleProps {
  title: string;
  value: string;
}

export const ModalSubTitle: React.FC<ModalSubTitleProps> = ({ title, value }) => {
  return (
    <>
      <Spacer $px={4} />
      <S.Div>
        <Poppins className="m-sub-title">{title}:</Poppins>
        <Poppins className="m-sub-value" px={14} weight={500}>
          {value}
        </Poppins>
      </S.Div>
    </>
  );
};
